import { render, staticRenderFns } from "./Compact.vue?vue&type=template&id=3508fadf&scoped=true&"
import script from "./Compact.vue?vue&type=script&lang=js&"
export * from "./Compact.vue?vue&type=script&lang=js&"
import style0 from "./Compact.vue?vue&type=style&index=0&id=3508fadf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3508fadf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VImg,VTextField})
